module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Getting the Most Out of "), _c('i', [_vm._v("David")])])]), _vm._v(" "), _c('div', {
    staticClass: "table",
    attrs: {
      "id": "tableau-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "6px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "5%",
      "padding": "6px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "40%",
      "padding": "6px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "55%",
      "padding": "6px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "6px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Lord Looks at the Heart")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Samuel 16:1-13")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "6px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("The Battle Is the Lord’s")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Samuel 17")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "6px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("True Friendship")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Samuel 20:1-17, 30-42")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "6px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("A Matter of Conscience")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Samuel 24")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "6px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("5")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Secure in the Lord")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Samuel 25")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "6px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Finding Strength in the Lord")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Samuel 30:1-25")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "6px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("God’s Wrath & Blessing")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Samuel 6")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "6px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("God’s Promise to David")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Samuel 7")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "6px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Facing Temptation")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Samuel 11")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "6px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("God’s Severe Mercy")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Samuel 12")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "6px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("11")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Misplaced Trust")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Chronicles 21:1—22:1")])])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "6px"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap_autre"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Generous Giving")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "6px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Chronicles 29")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leader’s Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 60
// module chunks = 0